import LazyLoad from "vanilla-lazyload";
import ReedsyExitModal from "@reedsy/exit-modal";
class CountdownHandler {
  constructor(countdownElClass) {
    const countdownEls = document.querySelectorAll(countdownElClass);
    if (!countdownEls.length) {
      return;
    }
    countdownEls.forEach((countdownEl) => {
      const countDownDate = new Date(countdownEl.dataset.date).getTime();
      const x = setInterval(() => {
        const now = (/* @__PURE__ */ new Date()).getTime();
        const distance = countDownDate - now;
        const day = Math.floor(distance / (1e3 * 60 * 60 * 24));
        const hr = Math.floor(
          distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
        );
        const min = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60));
        const sec = Math.floor(distance % (1e3 * 60) / 1e3);
        const dayEl = countdownEl.querySelector(".day");
        const hrEl = countdownEl.querySelector(".hr");
        const minEl = countdownEl.querySelector(".min");
        const secEl = countdownEl.querySelector(".sec");
        if (!dayEl || !hrEl || !minEl || !secEl) {
          return;
        }
        dayEl.innerHTML = `${day} <small>days</small>`;
        hrEl.innerHTML = `${hr} <small>hrs</small>`;
        minEl.innerHTML = `${min} <small>mins</small>`;
        secEl.innerHTML = `${sec} <small>secs</small>`;
        if (distance < 0) {
          clearInterval(x);
          countdownEl.textContent = "EXPIRED";
        }
      }, 1e3);
    });
  }
}
class VideoModalsHandler {
  constructor(reedsyVideoElementId) {
    this.iframe = document.getElementById(reedsyVideoElementId);
    if (!this.iframe)
      return;
    this.iframeContent = this.iframe.contentWindow || this.iframe.contentDocument;
    this.muteEl = document.getElementById("reedsy-modal--mute-toggle");
    if (!this.iframeContent)
      return;
    if (!this.muteEl)
      return;
    this.muteEl.addEventListener("click", () => {
      this.muteEl.classList.add("hidden");
      this.iframeContent.postMessage("reedsy-player-unmute", "*");
    });
  }
  pauseVideo() {
    if (!this.iframeContent)
      return;
    this.iframeContent.postMessage("reedsy-player-pause", "*");
  }
  playVideo() {
    if (!this.iframeContent)
      return;
    this.iframeContent.postMessage("reedsy-player-play", "*");
  }
}
class CarouselHandler {
  constructor(el) {
    this.timer = null;
    this.currentCarouselIndex = 0;
    this.loadingTimer = null;
    this.retryCount = 0;
    this.initialized = false;
    this.DEFAULT_SLIDE_DURATION = 3e3;
    this.MAX_RETRIES = 100;
    this.RETRY_INTERVAL = 200;
    this.MAX_FILE_SIZE = 1e6;
    this.rootContainer = document.querySelector(el);
    if (!this.rootContainer) {
      return;
    }
    this.dotsContainer = this.rootContainer.querySelector(
      ".reedsy-modal--carousel-dots"
    );
    this.checkboxEls = Array.from(
      this.rootContainer.querySelectorAll(".reedsy-modal--checkbox")
    );
    this.carouselContainer = this.rootContainer.querySelector(
      ".reedsy-modal--carousel"
    );
    this.carouselItems = Array.from(
      this.rootContainer.querySelectorAll(".reedsy-modal--carousel-item")
    );
    this.init();
  }
  init() {
    if (!this.dotsContainer || !this.checkboxEls || !this.carouselContainer || this.carouselItems.length === 0) {
      this.initialized = false;
      return;
    }
    this.setupLazyLoad();
    this.setupCheckboxes();
    this.setupDots();
    this.initialized = true;
  }
  autoPlay() {
    if (this.initialized) {
      this.loadSlide(this.currentCarouselIndex);
    }
  }
  setupLazyLoad() {
    this.lazyLoad = new LazyLoad({
      elements_selector: ".reedsy-modal--lazy-carousel",
      container: this.carouselContainer,
      cancel_on_exit: false,
      threshold: 50
      // Distance outside the contanier
    });
  }
  setupCheckboxes() {
    this.checkboxEls.forEach((checkbox, index) => {
      checkbox.addEventListener("click", () => this.setCarouselIndex(index));
    });
  }
  setupDots() {
    this.carouselItems.forEach((_, index) => {
      const dot = this.createDotElement(index);
      this.dotsContainer.appendChild(dot);
    });
  }
  createDotElement(index) {
    const dot = document.createElement("div");
    dot.classList.add("carousel-dot");
    dot.style.animationDuration = `${this.getDuration(index)}ms`;
    dot.addEventListener("click", () => this.setCarouselIndex(index));
    return dot;
  }
  setCarouselIndex(index) {
    this.updateActiveState(index);
    this.stopAutoPlay();
    this.scrollToItem(index);
  }
  scrollToItem(index) {
    this.pauseVideos();
    const scrollTarget = this.carouselItems.slice(0, index).reduce((acc, cur) => acc + cur.clientWidth, 0);
    this.carouselContainer.scrollTo({ left: scrollTarget, behavior: "smooth" });
    this.currentCarouselIndex = index;
  }
  loadSlide(index) {
    clearTimeout(this.loadingTimer);
    const slide = this.carouselItems[index].querySelector(
      ".reedsy-modal--lazy-carousel"
    );
    if (!slide)
      return;
    if (slide.classList.contains("loaded")) {
      this.updateActiveState(index);
      this.playVideo(index);
      this.scheduleSlide(index);
    } else if (this.retryCount < this.MAX_RETRIES) {
      this.retryLoadSlide(index);
    }
  }
  scheduleSlide(index) {
    const nextIndex = (index + 1) % this.carouselItems.length;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.scrollToItem(nextIndex);
      this.loadSlide(nextIndex);
    }, this.getDuration(index));
  }
  retryLoadSlide(index) {
    this.loadingTimer = setTimeout(() => {
      this.retryCount += 1;
      this.loadSlide(index);
    }, this.RETRY_INTERVAL);
  }
  updateActiveState(currIndex) {
    this.checkboxEls.forEach(
      (checkbox, idx) => checkbox.classList.toggle("active", idx === currIndex)
    );
    const dotEls = this.dotsContainer.querySelectorAll(".carousel-dot");
    dotEls.forEach((dotEl, idx) => {
      dotEl.classList.toggle("active", idx === currIndex);
      dotEl.classList.toggle("passed", idx < currIndex);
    });
  }
  playVideo(index) {
    const video = this.carouselItems[index].querySelector("video");
    if (!video)
      return;
    const fileSize = parseInt(video.dataset.fileSize || "0", 10);
    if (video.readyState >= 2 && fileSize < this.MAX_FILE_SIZE) {
      video.currentTime = 0;
      video.play();
    }
  }
  pauseVideos() {
    this.rootContainer.querySelectorAll("video").forEach((video) => video.pause());
  }
  // This is called from the modals handler
  // To stop auto scrolling when the modal is closed
  stopAutoPlay() {
    clearTimeout(this.timer);
    clearTimeout(this.loadingTimer);
  }
  getDuration(index) {
    return parseInt(
      this.carouselItems[index].dataset.duration || this.DEFAULT_SLIDE_DURATION,
      10
    );
  }
}
class ModalsHandler {
  constructor(exitModalElementId, sidebarModalElementId) {
    this.exitModalElementId = exitModalElementId;
    this.exitModalEl = document.getElementById(this.exitModalElementId);
    if (!this.exitModalEl) {
      return;
    }
    this.setupExitModal(this.exitModalElementId);
    this.configureCloseModal();
    this.configureFormTracking(this.exitModalEl);
    this.configureVideoTrigger("reedsy-modal--play-trigger");
    this.triggerOnScrollUp();
    this.sidebarModalElementId = sidebarModalElementId;
    this.sidebarModalEl = document.getElementById(this.sidebarModalElementId);
    if (!this.sidebarModalEl) {
      return;
    }
    this.configureFormTracking(this.sidebarModalEl, true);
  }
  setupExitModal(exitModalElementId) {
    var _a, _b;
    const self = this;
    const devMode = this.exitModalEl.dataset.env === "development";
    const period = (_a = this.exitModalEl.dataset.period) != null ? _a : "weeks";
    const frequency = (_b = this.exitModalEl.dataset.frequency) != null ? _b : 1;
    self.exitModal = new ReedsyExitModal(exitModalElementId, {
      callback: this.showModalCallback.bind(self),
      key: this.exitModalEl.dataset.key,
      classes: {
        hidden: "hidden",
        visible: "visible"
      },
      aggressive: devMode,
      reenableAfter: {
        type: period,
        // 'days', 'hours', 'minutes' or 'weeks'
        value: frequency
        // Integer value
      }
    });
  }
  showModalCallback() {
    this.sendEvent("modal-impression");
    const REEDSY_VIDEO_ELEMENT_ID = "reedsy-video";
    window.ReedsyModals.videoModalHandler = window.ReedsyModals.videoModalHandler || new VideoModalsHandler(REEDSY_VIDEO_ELEMENT_ID);
    const CAROUSEL_ID = ".exit-modal .reedsy-modal--carousel-container";
    window.ReedsyModals.carouselHandler = window.ReedsyModals.carouselHandler || new CarouselHandler(CAROUSEL_ID);
    window.ReedsyModals.carouselHandler.autoPlay();
  }
  sendEvent(eventName) {
    const modalEl = this.exitModalEl;
    const { title } = modalEl.dataset;
    const { served } = modalEl.dataset;
    const { tags } = modalEl.dataset;
    const { testStartDate } = modalEl.dataset;
    const { header } = modalEl.dataset;
    const { description } = modalEl.dataset;
    const { featuredImage } = modalEl.dataset;
    const pathName = window.location.href.replace(/(\/|#.*|\?.*)?$/, "");
    const pageUid = document.body.dataset.pageUid || modalEl.dataset.pageUid;
    const { pageTitle } = document.body.dataset;
    const variables = {
      currentPath: pathName,
      modalName: title,
      modalHeader: header,
      modalDescription: description,
      modalImage: featuredImage,
      testServed: served,
      testStartDate,
      tags,
      pageUid,
      pageTitle
      // A built-in GA event
    };
    if (typeof window.Reedsy === "undefined") {
      console.error("window.Reedsy undefined.");
      return;
    }
    if (typeof window.Reedsy.RAM === "undefined") {
      console.error("window.Reedsy.RAM undefined.");
      return;
    }
    window.Reedsy.RAM.pushEvent(eventName, variables);
  }
  configureVideoTrigger(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.closest(".reedsy-modal--video").addEventListener("click", () => {
        this.exitModal.show(true);
      });
    }
  }
  hideModal() {
    const video = window.ReedsyModals && window.ReedsyModals.videoModalHandler;
    if (video) {
      window.ReedsyModals.videoModalHandler.pauseVideo();
    }
    const carousel = window.ReedsyModals && window.ReedsyModals.carouselHandler;
    if (carousel) {
      carousel.stopAutoPlay();
    }
    this.exitModal.hide();
  }
  configureCloseModal() {
    const closeEls = document.querySelectorAll(
      ".reedsy-modal--close, .reedsy-modal--overlay"
    );
    if (closeEls) {
      closeEls.forEach((closeEl) => {
        closeEl.addEventListener("click", () => {
          this.hideModal();
        });
      });
    }
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.hideModal();
      }
    });
  }
  // NOTE this event listener should be scheduled first, before
  // the client captcha code, to ensure tracking happens before
  // Captcha prevents default and submits
  configureFormTracking(parentEl, impressOnSubmit = false) {
    const formEl = parentEl.querySelector("form");
    if (!formEl) {
      return;
    }
    formEl.addEventListener("submit", () => {
      if (impressOnSubmit) {
        this.sendEvent("modal-impression");
        this.exitModal.disable();
      }
      this.sendEvent("modal-submit");
      const submitButtonEls2 = formEl.querySelectorAll(
        ".reedsy-modal--submit-validate"
      );
      if (submitButtonEls2) {
        submitButtonEls2.forEach((buttonEl) => {
          const el = buttonEl;
          el.disabled = true;
          el.textContent = "Submitting...";
          el.value = "Submitting...";
        });
      }
    });
    const submitButtonEls = formEl.querySelectorAll('button[type="submit"]');
    if (submitButtonEls) {
      submitButtonEls.forEach((buttonEl) => {
        buttonEl.addEventListener("click", () => {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "subscription_method";
          hiddenInput.value = buttonEl.value;
          formEl.appendChild(hiddenInput);
        });
      });
    }
    const socialButtonEls = parentEl.querySelectorAll(
      "[data-social-modal-trigger]"
    );
    if (socialButtonEls) {
      socialButtonEls.forEach((socialButtonEl) => {
        socialButtonEl.addEventListener("click", () => {
          if (impressOnSubmit) {
            this.sendEvent("modal-impression");
          }
          this.sendEvent("modal-submit");
        });
      });
    }
  }
  triggerOnScrollUp() {
    let lastScrollTop = 0;
    const delta = 5;
    const { exitModal } = this;
    function shouldTriggerModal() {
      const st = document.scrollingElement.scrollTop;
      const isScrollUp = st < lastScrollTop;
      const isScrolledEnough = Math.abs(lastScrollTop - st) > delta;
      const isNarrowScreen = window.innerWidth < 900;
      if (isScrollUp && isScrolledEnough && isNarrowScreen) {
        exitModal.show();
      }
      lastScrollTop = st;
    }
    let ticking = false;
    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          shouldTriggerModal();
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
  }
}
class TypeformModalHandler {
  constructor(typeformElClass) {
    let isAttached = false;
    const typeformEls = document.querySelectorAll(typeformElClass);
    if (!typeformEls.length || isAttached) {
      return;
    }
    typeformEls.forEach((typeformEl) => {
      typeformEl.addEventListener("click", (ev) => {
        ev.preventDefault();
        if (isAttached) {
          TypeformModalHandler.makeTypeform(typeformEl);
        }
        if (!isAttached) {
          const scriptEl = document.createElement("script");
          scriptEl.src = "https://embed.typeform.com/embed.js?typeform-welcome=0";
          document.body.appendChild(scriptEl);
          typeformEl.textContent = "Loading...";
          scriptEl.onload = () => {
            typeformEl.textContent = "Start quiz";
            TypeformModalHandler.makeTypeform(typeformEl);
            isAttached = true;
          };
        }
        if (!!window.ReedsyModals && !!window.ReedsyModals.exitModalHandler && typeformEl.hasAttribute("data-trigger-impression")) {
          window.ReedsyModals.exitModalHandler.sendEvent("modal-impression");
          window.ReedsyModals.exitModalHandler.exitModal.disable();
        }
        TypeformModalHandler.closeModal();
      });
    });
  }
  static makeTypeform(typeformEl) {
    window.typeformEmbed.makePopup(typeformEl.dataset.url, {
      size: 70,
      hideHeaders: true,
      autoOpen: true,
      autoClose: 5,
      onSubmit() {
        if (!!window.ReedsyModals && !!window.ReedsyModals.exitModalHandler) {
          if (window.ReedsyModals.exitModalHandler.exitModal) {
            window.ReedsyModals.exitModalHandler.exitModal.disable();
          }
          window.ReedsyModals.exitModalHandler.sendEvent("modal-submit");
        }
      }
    });
  }
  static closeModal() {
    if (!!window.ReedsyModals && !!window.ReedsyModals.exitModalHandler && !!window.ReedsyModals.exitModalHandler.exitModal) {
      window.ReedsyModals.exitModalHandler.exitModal.hide();
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const EXIT_MODAL_ELEMENT_ID = "exit-modal";
  const SIDEBAR_MODAL_ELEMENT_ID = "sidebar-modal";
  const TYPEFORM_ELEMENT_CLASS = ".reedsy-modal--start-quiz";
  const COUNTDOWN_CLASS = ".reedsy-modal--countdown";
  const SIDEBAR_CARAOUSEL = ".sidebar-modal .reedsy-modal--carousel-container";
  const LAZYLOAD_CLASS = ".reedsy-modal--lazy";
  window.ReedsyModals = window.ReedsyModals || {};
  window.ReedsyModals.exitModalHandler = new ModalsHandler(
    EXIT_MODAL_ELEMENT_ID,
    SIDEBAR_MODAL_ELEMENT_ID
  );
  window.ReedsyModals.typeformModalHandler = new TypeformModalHandler(
    TYPEFORM_ELEMENT_CLASS
  );
  window.ReedsyModals.countdownHandler = new CountdownHandler(COUNTDOWN_CLASS);
  window.ReedsyModals.sidebarCarouselHandler = new CarouselHandler(
    SIDEBAR_CARAOUSEL
  );
  window.ReedsyModals.sidebarCarouselHandler.autoPlay();
  function createModalsHandler(exitModalId) {
    return new ModalsHandler(exitModalId);
  }
  window.ReedsyModals.createModalsHandler = createModalsHandler;
  window.ReedsyModals.lazyLoadInstance = new LazyLoad({
    elements_selector: LAZYLOAD_CLASS
  });
});
